const IMAGES = {
  men: {
    "Sac-a-Dos-Camel-01_700x": {
      name: "LEATHER BACKPACK CAMEL",
      value: require("../assets/images/Sac-a-Dos-Camel-01_700x.jpg"),
      price:'$275.00'
    },

    "Sac-a-Dos-Camel-02_700x": require("../assets/images/Sac-a-Dos-Camel-02_700x.jpg"),
    "Sac-a-Dos-Camel-03_700x": require("../assets/images/Sac-a-Dos-Camel-03_700x.jpg"),
    "Sac-a-Dos-Camel-04_700x": require("../assets/images/Sac-a-Dos-Camel-04_700x.jpg"),
    "Nouveau-Cartable-marron-01_700x": {
      name: "LE NOUVEAU CARTABLE BROWN",
      value: require("../assets/images/Nouveau-Cartable-marron-01_700x.jpg"),
      price:'$350.00'
    },

    "Nouveau-Cartable-marron-02_700x": require("../assets/images/Nouveau-Cartable-marron-02_700x.jpg"),
    "Nouveau-Cartable-marron-03_700x": require("../assets/images/Nouveau-Cartable-marron-03_700x.jpg"),
    "Nouveau-Cartable-marron-04_700x": require("../assets/images/Nouveau-Cartable-marron-04_700x.jpg"),
    "Sac-Voyage-Noir-01_700x": {
      name: "LE VOYAGEUR BLACK",
      value: require("../assets/images/Sac-Voyage-Noir-01_700x.jpg"),
      price:'$400.00'
    },

    "Sac-Voyage-Noir-02_700x": require("../assets/images/Sac-Voyage-Noir-02_700x.jpg"),
    "Sac-Voyage-Noir-03_700x": require("../assets/images/Sac-Voyage-Noir-03_700x.jpg"),
    "Sac-Voyage-Noir-04_700x": require("../assets/images/Sac-Voyage-Noir-04_700x.jpg"),
    "Le-Nouveau-Cartable-Kaki-01_700x": {
      name: "LE NOUVEAU CARTABLE OLIVE",
      value: require("../assets/images/Le-Nouveau-Cartable-Kaki-01_700x.jpg"),
      price:'$350.00'
    },

    "Le-Nouveau-Cartable-Kaki-02_700x": require("../assets/images/Le-Nouveau-Cartable-Kaki-02_700x.jpg"),
    "Le-Nouveau-Cartable-Kaki-03_700x": require("../assets/images/Le-Nouveau-Cartable-Kaki-03_700x.jpg"),
    "Le-Nouveau-Cartable-Kaki-04_700x": require("../assets/images/Le-Nouveau-Cartable-Kaki-04_700x.jpg"),
  },
  women: {
    "Elegant-Bag-Noir-01_700x": {
      name: "THE ELEGANT BAG BLACK",
      value: require("../assets/images/Elegant-Bag-Noir-01_700x.jpg"),
      price:'$330.00'
    },
    "Elegant-Bag-Noir-02_700x": require("../assets/images/Elegant-Bag-Noir-02_700x.jpg"),
    "Elegant-Bag-Noir-03_700x": require("../assets/images/Elegant-Bag-Noir-03_700x.jpg"),
    "Elegant-Bag-Noir-04_700x": require("../assets/images/Elegant-Bag-Noir-04_700x.jpg"),
    "Circle-Bag-Olive-01_700x": {
      name: "LE CIRCLE BAG OLIVE",
      value: require("../assets/images/Circle-Bag-Olive-01_700x.jpg"),
      price:'$250.00'
    },
    "Circle-Bag-Olive-02_700x": require("../assets/images/Circle-Bag-Olive-02_700x.jpg"),
    "Circle-Bag-Olive-03_700x": require("../assets/images/Circle-Bag-Olive-03_700x.jpg"),
    "Circle-Bag-Olive-04_700x": require("../assets/images/Circle-Bag-Olive-04_700x.jpg"),
    "Petit-Violette-Violet-01_700x": {
      name: "LE PETIT VIOLETTE PURPLE",
      value: require("../assets/images/Petit-Violette-Violet-01_700x.jpg"),
      price:'$290.00'
    },
    "Petit-Violette-Violet-02_700x": require("../assets/images/Petit-Violette-Violet-02_700x.jpg"),
    "Petit-Violette-Violet-03_700x": require("../assets/images/Petit-Violette-Violet-03_700x.jpg"),
    "Petit-Violette-Violet-04_700x": require("../assets/images/Petit-Violette-Violet-04_700x.jpg"),
    "Petit-Sac-Rouge-01_700x": {
      name: "LE PETIT SAC RED",
      value: require("../assets/images/Petit-Sac-Rouge-01_700x.jpg"),
      price:'$190.00'
    },
    "Petit-Sac-Rouge-02_700x": require("../assets/images/Petit-Sac-Rouge-02_700x.jpg"),
    "Petit-Sac-Rouge-03_700x": require("../assets/images/Petit-Sac-Rouge-03_700x.jpg"),
    "Petit-Sac-Rouge-04_700x": require("../assets/images/Petit-Sac-Rouge-04_700x.jpg"),
  },
};
export default IMAGES;
